import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()

export class RegisterService extends ServiceGlobal {
    email: string;

    tableName() { return 'user'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            email: 'Email',
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "email": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    "email": true,
                },
            },
        });
    }

    forgot() {
        let api = API.FORGOTPASSWORD;
        let attributes = this.getAttributesNotEmpty();
        if(attributes['email']) {
            console.log(attributes['email'].trim());
            api = api.replace('{email_address}', attributes['email'].trim());
            return this._db.getWithClientCredentialAuth(api).then(res => {
                return Promise.resolve(res);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/register.service.ts